<template>
  <div>
    <!-- 时间设置 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t('messageAdd.time.001') }}</span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.autoDate") }}:</span>
        <el-select size="medium"  v-model="t.atz">
          <el-option
            :label="$t('message.systemMsg.switchSelect.open')"
            :value="true"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.switchSelect.close')"
            :value="false"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.autoTimeZone") }}:</span>
        <el-select size="medium"  v-model="t.at">
          <el-option
            :label="$t('message.systemMsg.switchSelect.open')"
            :value="true"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.switchSelect.close')"
            :value="false"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t('messageAdd.time.002') }}:</span>
        <el-select size="medium"  v-model="t.ss">
          <el-option
            :label="$t('message.systemMsg.switchSelect.002')"
            :value="true"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.switchSelect.001')"
            :value="false"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "timeSetting",
  props: {
    timeSet:{
      type:Object
    }
  },
  data() {
    return {
    
    };
  },
  computed:{
      t(){
      return this.timeSet
      }
    },
  watch:{
   // 监听 t 的变化，并通知父组件
   t: {
      handler(newVal) {
        this.$emit('update:timeSet', newVal);
        this.$emit('update:config-timeSet', newVal);
      },
      deep: true // 深度监听对象的变化
    }
  },
  methods: {},
}
</script>